import { GlobalStore } from '@/store';
import { useQuasar } from 'quasar';

const exam = {
	aaa: () => {
		// console.log('--eval_cal--aaa----');
	},
};

// 지문의 넘버링 각 지문에 딸린 문제는 3 or 4
export function setHeaderNo4SAT(arr, _tmpPdata) {
	// console.log('--initExams-problems-', _tmpPdata);
	const arrHeaderIDcount = [];
	const getHeaderID = no => _tmpPdata[no].data.content.headerId;
	// for (let i = 1; i < 35; i++) {
	for (const [i] of Object.entries(_tmpPdata)) {
		arrHeaderIDcount.push(getHeaderID(i));
	}
	// console.log('--initExams-arrHeaderIDcount-', arrHeaderIDcount);
	const arrTotal = arrHeaderIDcount.reduce((obj, cur) => {
		obj[cur] = (obj[cur] || 0) + 1;
		return obj;
	}, {});
	// console.log('--initExams-arrTotal-', arrTotal);
	arrHeaderIDcount.reduce((preID, curID, i) => {
		// console.log('--initExams-preID-curID:', i, preID, curID);
		if (preID !== curID) {
			const count = arrTotal[curID];
			const result = `[${i + 1}~${i + count}]`;
			// console.log('--initExams-count-result:', i, count, result);
			for (let j = i; j < i + count; j++) {
				// console.log('--initExams- for result:', result);
				arr.value.push(result);
			}
		}
		return curID;
	}, 0);
	// console.log('--initExams-arrHeaderNo-', arr.value);
}

export function setDeviceVersion() {
	const gStore = GlobalStore();
	const $q = useQuasar();
	gStore.setPlatform('DESKTOP');
	if ($q.platform.is.android) gStore.setPlatform('ANDROID');
	if ($q.platform.is.ios) gStore.setPlatform('IOS');
	// console.log('--setDeviceVersion-gStore.platform-', gStore.platform);
}
export function getNumber(val) {
	switch (val) {
		case '①':
			return 1;
		case '②':
			return 2;
		case '③':
			return 3;
		case '④':
			return 4;
		case '⑤':
			return 5;
		default:
			return -1;
	}
}

export function getCorrectNo(arr) {
	// console.log('- -getCorrectNo-arr-', arr);
	for (const e of arr) {
		const text = e.answer;
		if (text.includes('①')) return 1;
		if (text.includes('②')) return 2;
		if (text.includes('③')) return 3;
		if (text.includes('④')) return 4;
		if (text.includes('⑤')) return 5;
	}
	return -1;
}

////  지문 넘버링 ////
export const headerQbankWithNo = (headerTitle, unitNo) => {
	// console.log('-초기값-headerQbankWithNo-headerTitle-', headerTitle);
	if (headerTitle) {
		let hSetence = headerTitle;

		const gStore = GlobalStore();
		const lineHeightVW = gStore.platform === 'DESKTOP' ? 1.71 : 2.71; // 모바일 간격 조정.

		// 지문에 lineHeight 적용
		hSetence = rrHtml(
			hSetence,
			'<div >',
			`<div style="line-height:${lineHeightVW}vw">`
		);
		// 쓸데없는 div 삭제 or 단순 교체
		hSetence = rrHtml(hSetence, '</div><div style="font-size: 15.6pt">', '');
		hSetence = rrHtml(hSetence, '</div><div style="font-size:15.6pt;">', '');
		hSetence = rrHtml(
			hSetence,
			'</div><div style="font-size:14.3pt;"><strong> </strong></div><div style="font-size:14.3pt;">',
			''
		);
		// hSetence = rrHtml(hSetence, 'style="text-align:center;margin-left:0px;margin-right:0px;text-indent:0px;', 'style="text-align:left;margin-left:0px;margin-right:0px;text-indent:0px;');  //  네모안의 보기 왼쪽 정렬

		// 지문최상단 라인에 weight 적용 + 번호삽입
		hSetence = rrHtml(
			hSetence,
			'">※',
			';font-weight: 700; line-height: 2.6vw">※' + createContentsNoStr(unitNo)
		);
		hSetence = rrHtml(
			hSetence,
			'"><strong>※ </strong></div><div style="font-size:14.3pt;">',
			';font-weight: 700; line-height: 2.6vw">※' + createContentsNoStr(unitNo)
		);
		hSetence = rrHtml(
			hSetence,
			'"><strong>※',
			';font-weight: 700; line-height: 2.6vw">※' + createContentsNoStr(unitNo)
		);

		// console.log('-수정결과-headerQbankWithNo-hSetence-', hSetence);
		return hSetence;
	}
	return headerTitle;
};

//  replace  String
const rrHtml = (text, pick, replace) =>
	text.includes(pick) ? text.replace(pick, replace) : text;

const createContentsNoStr = unitNo => {
	const no = Number(unitNo);
	const aaaa = no % 3;
	const bbbb =
		aaaa == 1
			? `${no}-${no + 2}`
			: aaaa == 2
			? `${no - 1}-${no + 1}`
			: `${no - 2}-${no}`;
	return '[' + bbbb + '] ';
};

//////////////////////////////////////////////
////////////////----Dialog----////////////////
export const showDialog = (q, message) => {
	q.dialog({
		message: message,
		persistent: true,
	});
};
export const showErrorNoData = (q, message) => {
	q.dialog({
		message: `${message} 관리자에게 문의하세요.`,
		persistent: true,
	});
};
export const showErrorConnection = q => {
	q.dialog({
		message: '인터넷 연결상태를 체크하고 다시 접속해주세요.',
		persistent: true,
	});
};

// const showDialogGoToLogin = (q, message, errorLog, callback) => {
//     console.error('--showDialogGoToLogin--', errorLog)
//     q.dialog({
//         message: message,
//         // cancel: true,
//         persistent: true,
//     }).onOk();
//     // .onCancel(() => {
//     //     console.log('--onCancel--:');
//     // });
// };

//확인문제 큐뱅크 오류 - char데이타 강제생성 + 삽입.
export const getAddCharQbankData = data => {
	// console.log('--getQuestion_old- vvvv-', data.content.problem.question.texts[1].elements[0].textBox.elements[0].text.elements[0].char)
	// console.log('--getQuestion_old- ffff-', data.content.problem.question.texts[1].elements[0].textBox.elements[0].text.elements[0].char)
	// console.log('--getQuestion_old- aaaa-',data.content.problem.question.texts[1].elements[0].textBox.elements[0].text.elements[0].char.content)

	const char =
		data.content.problem.question.texts[1].elements[0].textBox.elements[0].text
			.elements[0].char;
	// console.log('--getQuestion_old- char-', char)
	// 문제
	if (!char) {
		// const content = data.content.problem.question.texts[1].elements[0].textBox.elements[0].text.content
		// const imgPath = data.content.problem.question.texts[1].elements[0].textBox.elements[0].text.elements[0].image.path
		// console.log('--getQuestion_old- content-', content)
		// console.log('--getQuestion_old- imgPath-', imgPath)
		const newChar = {
			char: {
				backColor: '',
				foreColor: '',
				size: 15.6,
				content:
					data.content.problem.question.texts[1].elements[0].textBox.elements[0]
						.text.content,
				elements: [
					{
						image: {
							path: data.content.problem.question.texts[1].elements[0].textBox
								.elements[0].text.elements[0].image.path,
							width: 83,
							height: 28,
							sound: false,
							movie: false,
							multimedia: null,
							iedata: null,
							valign: null,
							float: null,
						},
					},
				],
				decorations: [],
			},
		};

		data.content.problem.question.texts[1].elements[0].textBox.elements[0].text.elements[0] =
			newChar;
	}
	// 보기
	const noChar =
		data.content.problem.choice.items[0].texts[0].elements.length === 0;
	if (noChar) {
		data.content.problem.choice.items.forEach((e, i) => {
			e.texts.forEach(e => {
				e.elements = [
					{
						char: {
							backColor: '',
							foreColor: '',
							size: 15.6,
							content: '',
							elements: [],
							decorations: [],
						},
					},
					{
						char: {
							backColor: '',
							foreColor: '',
							size: 15.6,
							content: data.content.problem.choice.items[i].texts[0].content,
							elements: [],
							decorations: [],
						},
					},
					{
						char: {
							backColor: '',
							foreColor: '',
							size: 15.6,
							content: '',
							elements: [],
							decorations: [],
						},
					},
				];
			});
		});
	}
	return data;
};

export default exam;
